import PropTypes from 'prop-types';
import { find, path, pathOr, propEq } from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { readEndpoint, updateResource, deleteResource } from 'redux-json-api';

import { Grid, Row, Col } from 'react-flexbox-grid';
import CardHeader from '@material-ui/core/CardHeader';

import { closeLeftBar, showSnackbarMessage } from '../modules/actions/layout';
import RouteBlockageForm from './RouteBlockageForm';

class RouteBlockageEdit extends Component {
  static propTypes = {
    readEndpoint: PropTypes.func.isRequired,
    updateResource: PropTypes.func.isRequired,
    deleteResource: PropTypes.func.isRequired,
    apiEndpoint: PropTypes.string.isRequired,
    closeLeftBar: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
    extra: PropTypes.shape({}),
  };

  render() {
    const {
      updateResource,
      deleteResource,
      apiEndpoint,
      closeLeftBar,
      showSnackbarMessage,
      routeBlockage,
    } = this.props;
    const initialValues = {
      expected_duration: routeBlockage.attributes['expected-duration'],
      start_at: routeBlockage.attributes['start-at'],
      railway: routeBlockage.relationships.railway.data.id,
      stop_from: routeBlockage.relationships['stop-from'].data.id,
      stop_to: routeBlockage.relationships['stop-to'].data.id,
      vehicles_required: routeBlockage.attributes['vehicles-required'],
      companies: routeBlockage.relationships['invited-companies'].data.map(c => c.id),
      preferred_companies: routeBlockage.relationships['invited-preferred-companies'].data.map(c => c.id),
      invite_non_preferred_companies: routeBlockage.attributes['invite-non-preferred-companies'],
    };

    return (
      <Grid fluid>
        <Row>
          <Col style={{ margin: 20 }}>
            <CardHeader title="Stremming wijzigen" />

            <RouteBlockageForm
              initialValues={initialValues}
              onSubmit={async (values) => {
                try {
                  const entity = {
                    type: 'route-blockage',
                    id: routeBlockage.id,
                    attributes: {
                      'expected-duration': values.expected_duration,
                      'start-at': values.start_at,
                      'railway': `${apiEndpoint}/railway/${values.railway}`,
                      'stop-from': `${apiEndpoint}/stop/${values.stop_from}`,
                      'stop-to': `${apiEndpoint}/stop/${values.stop_to}`,
                      'vehicles-required': values.vehicles_required,
                      'invited-preferred-companies': values.preferred_companies.map(companyId => (
                        `${apiEndpoint}/company/${companyId}`
                      )),
                      'invited-companies': values.companies.map(companyId => (
                        `${apiEndpoint}/company/${companyId}`
                      )),
                      'invite-non-preferred-companies': values.invite_non_preferred_companies,
                    },
                  };

                  await updateResource(entity);
                  closeLeftBar();
                  showSnackbarMessage('Stremming gewijzigd');
                } catch (exc) {
                  console.warn('exception', exc);
                }
              }}
              onEndBlockage={async (event) => {
                try {
                  const entity = {
                    type: 'route-blockage',
                    id: routeBlockage.id,
                    attributes: {
                      'ended-at': new Date(),
                    },
                  };

                  closeLeftBar();
                  //await updateResource(entity);
                  await deleteResource(entity);
                  showSnackbarMessage('Stremming beëindigd');
                  //readEndpoint('route-blockage?filter[ended-at__isnull]=True');
                } catch (exc) {
                  console.warn('exception', exc);
                  showSnackbarMessage('Er is iets fout gegaan bij het beëindigen van de stremming!');
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
}

const selectRouteBlockage = (state, id) => {
  const routeBlockages = pathOr([], ['api', 'route-blockage', 'data'], state);

  return find(propEq('id', id))(routeBlockages);
};

const mapStateToProps = (state, ownProps) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
  routeBlockage: selectRouteBlockage(state, ownProps.extra.id),
});

const mapDispatchToProps = {
  readEndpoint,
  updateResource,
  deleteResource,
  closeLeftBar,
  showSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteBlockageEdit);
